import React from 'react';

export const AddIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 1V11M1 6H11" stroke="#FEFEFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
);
